var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:_vm.telop.type === 'success' ? 'telop'
        : _vm.telop.type === 'warning' ? 'telop--yellow'
          : _vm.telop.type === 'error' ? 'telop--red' : ''},[_c('p',{staticClass:"telop__text"},[_vm._v(_vm._s(_vm.telop.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }